import React from 'react';
import styles from '../../styles/common/RoleToggleFeedback.module.css';

const RoleToggleFeedback = ({ role, onRoleChange, onFeedback }) => (
  <div className={styles.container}>
    <div className={styles.roleToggle}>
      <label className={styles.switch}>
        <input 
          type="checkbox" 
          checked={role === 'Landlord'} 
          onChange={() => onRoleChange(role === 'Tenant' ? 'Landlord' : 'Tenant')} 
        />
        <span className={styles.slider}></span>
      </label>
      <span className={styles.roleLabel}>
        Viewing as: <strong>{role}</strong>
      </span>
    </div>
    <button className={styles.feedbackButton} onClick={onFeedback}>
      🐞 Report Bug / Provide Feedback
    </button>
  </div>
);

export default RoleToggleFeedback;
